import React, { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { 
  FiCheck, 
  FiLock, 
  FiShield, 
  FiEye, 
  FiEyeOff, 
  FiKey, 
  FiArrowRight, 
  FiRotateCcw 
} from "react-icons/fi";

const ChangePassword = () => {
  const { handleSubmit, register, reset, formState: { isSubmitting } } = useForm();
  const navigate = useNavigate();

  // Password visibility states
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const onSubmit = async (values) => {
    if (values.newPassword.length < 6) {
      toast.error("Min 6 Digit Password Needed");
      return;
    }

    if (values.newPassword !== values?.confirmpassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/auth/chnage_password`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: `${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          oldPassword: values.oldPassword,
          newPassword: values.newPassword,
        }),
      });

      if (!res.ok) {
        throw new Error("API ERROR");
      }

      const data = await res.json();

      if (data) {
        localStorage.removeItem("token");
        const token = localStorage.getItem("token");
        if (token === null) {
          reset();
          toast.success("Password updated successfully!");
          navigate("/login");
        } else {
          toast.error("Password Not Matched");
        }
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  return (
    // পুরো পেজের ব্যাকগ্রাউন্ড হোয়াইট
    <div className="min-h-screen w-full  text-gray-900 flex items-center justify-center p-4 sm:p-6 lg:p-8">
      
      {/* মূল কার্ড বা কন্টেইনারের ব্যাকগ্রাউন্ডও হোয়াইট */}
      <div className="w-full max-w-4xl bg-white border border-gray-200 rounded-2xl shadow-xl overflow-hidden grid grid-cols-1 lg:grid-cols-12">
        
        {/* বাঁপাশের সেকশন - হোয়াইট ব্যাকগ্রাউন্ড ও ডার্ক টেক্সট */}
        <aside className="lg:col-span-5 bg-white p-8 flex flex-col justify-between border-b lg:border-b-0 lg:border-r border-gray-200">
          <div>
            <div className="w-12 h-12 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center text-blue-600 mb-6">
              <FiShield className="text-2xl" />
            </div>

            <span className="text-xs font-semibold tracking-wider uppercase text-blue-600 bg-blue-50 px-3 py-1 rounded-full border border-blue-100 inline-block mb-3">
              Security Settings
            </span>

            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight mb-3">
              Protect your account
            </h1>

            <p className="text-gray-600 text-sm leading-relaxed mb-8">
              Update your credentials regularly to keep your workspace private, protected, and fully secure.
            </p>

            <div className="space-y-4 text-xs font-medium text-gray-700">
              <div className="flex items-start gap-3">
                <span className="mt-0.5 p-1 rounded-full bg-green-100 text-green-700 border border-green-200">
                  <FiCheck size={12} />
                </span>
                <span>Use a unique password not reused elsewhere</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="mt-0.5 p-1 rounded-full bg-green-100 text-green-700 border border-green-200">
                  <FiCheck size={12} />
                </span>
                <span>Keep your personal access token confidential</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="mt-0.5 p-1 rounded-full bg-green-100 text-green-700 border border-green-200">
                  <FiCheck size={12} />
                </span>
                <span>Minimum 6 characters with mixed casing</span>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-100 text-xs text-gray-500 flex items-center justify-between">
            <span>Last updated: Recently</span>
            <span className="flex items-center gap-1.5 text-green-600 font-medium">
              <span className="w-2 h-2 rounded-full bg-green-500"></span> Protected
            </span>
          </div>
        </aside>

        {/* ডানপাশের সেকশন - হোয়াইট ব্যাকগ্রাউন্ড ও ডার্ক টেক্সট */}
        <section className="lg:col-span-7 bg-white p-6 sm:p-8 flex flex-col justify-center">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="p-2.5 rounded-xl bg-gray-100 border border-gray-200 text-gray-700">
                <FiLock className="text-lg" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900">Change Password</h2>
                <p className="text-xs text-gray-500">Update credentials for enhanced access control</p>
              </div>
            </div>

            <button
              type="button"
              onClick={() => reset()}
              title="Reset Form"
              className="flex items-center gap-1 text-xs font-medium text-gray-500 hover:text-gray-900 transition-colors px-2.5 py-1.5 rounded-lg hover:bg-gray-100"
            >
              <FiRotateCcw className="text-xs" /> Reset
            </button>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
            {/* Current Password */}
            <div>
              <label htmlFor="oldPassword" className="block text-xs font-semibold text-gray-700 mb-1.5">
                Current Password <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type={showOldPassword ? "text" : "password"}
                  id="oldPassword"
                  placeholder="••••••••"
                  {...register("oldPassword", { required: true })}
                  className="w-full bg-white border border-gray-300 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 rounded-xl px-3.5 py-2.5 text-sm text-gray-900 placeholder-gray-400 transition-all outline-none pr-10"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowOldPassword(!showOldPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors p-1"
                >
                  {showOldPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                </button>
              </div>
            </div>

            {/* New Password */}
            <div>
              <label htmlFor="newPassword" className="block text-xs font-semibold text-gray-700 mb-1.5">
                New Password <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type={showNewPassword ? "text" : "password"}
                  id="newPassword"
                  placeholder="••••••••"
                  {...register("newPassword", { required: true })}
                  className="w-full bg-white border border-gray-300 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 rounded-xl px-3.5 py-2.5 text-sm text-gray-900 placeholder-gray-400 transition-all outline-none pr-10"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors p-1"
                >
                  {showNewPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                </button>
              </div>
            </div>

            {/* Confirm New Password */}
            <div>
              <label htmlFor="confirmpassword" className="block text-xs font-semibold text-gray-700 mb-1.5">
                Confirm New Password <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmpassword"
                  placeholder="••••••••"
                  {...register("confirmpassword", { required: true })}
                  className="w-full bg-white border border-gray-300 focus:border-blue-600 focus:ring-1 focus:ring-blue-600 rounded-xl px-3.5 py-2.5 text-sm text-gray-900 placeholder-gray-400 transition-all outline-none pr-10"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors p-1"
                >
                  {showConfirmPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                </button>
              </div>
            </div>

            {/* Password Requirement Box */}
            <div className="p-3.5 rounded-xl bg-gray-50 border border-gray-200 text-xs">
              <span className="font-semibold text-gray-800 block mb-1">Password Requirements</span>
              <ul className="grid grid-cols-2 gap-1 text-gray-600">
                <li className="flex items-center gap-1.5">• Minimum 6 characters</li>
                <li className="flex items-center gap-1.5">• At least 1 number</li>
                <li className="flex items-center gap-1.5">• At least 1 uppercase</li>
                <li className="flex items-center gap-1.5">• Match confirmation</li>
              </ul>
            </div>

            {/* Form Actions */}
            <div className="flex items-center justify-end gap-3 pt-3 border-t border-gray-100">
              <button
                type="button"
                onClick={() => reset()}
                className="px-4 py-2.5 rounded-xl text-xs font-semibold text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-all"
              >
                Discard
              </button>
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-xs font-semibold text-white bg-blue-600 hover:bg-blue-700 active:scale-[0.98] transition-all shadow-md shadow-blue-500/20 disabled:opacity-50"
              >
                <FiKey className="text-sm" />
                <span>Update Password</span>
                <FiArrowRight className="text-sm ml-0.5" />
              </button>
            </div>
          </form>
        </section>

      </div>
    </div>
  );
};

export default ChangePassword;